import type { PermitTypeListResponse } from '@contracts/permitType/PermitTypeListResponse';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';
import { PermitTypeList } from '@src/orders/domain/PermitType';

export interface PermitTypeFilters {
  name?: string;
  jurisdiction?: string;
  type?: string;
}

export const PermitTypesClient = {
  list: async (filters: PermitTypeFilters = {}): Promise<PermitTypeList> => {
    const { data: response } =
      await AuthenticatedClient.get<PermitTypeListResponse>('permitTypes', {
        params: filters,
      });

    return new PermitTypeList(response.permitTypes);
  },
  listCompatibleFor: async (
    permitApplicationId: string,
  ): Promise<PermitTypeList> => {
    const { data: response } =
      await AuthenticatedClient.get<PermitTypeListResponse>(
        `permitTypes/compatibleFor/${permitApplicationId}`,
      );

    return new PermitTypeList(response.permitTypes);
  },
};
